
export default class HashScrolling {
	static init() {
		// scroll to hash on load
		window.addEventListener('load', () => {
            setTimeout(() => {
                HashScrolling.scrollToLinkHash(window.location.hash);
            }, 1000);
		});

		window.addEventListener('click', (e) => {
			const link = e.target.closest('a');
            if (link && link.hash && link.href.replace(location.href.replace(location.hash, ''), '') === link.hash) {
				e.preventDefault();
				e.stopPropagation();
				HashScrolling.scrollToLinkHash(link.hash);
			}
		});
	}

    static _getScrollTop(targetElement) {
        const header = document.getElementById('header');
        return targetElement.getBoundingClientRect().top + window.scrollY - header.getBoundingClientRect().height - 10;
    }

    /**
     * @param {string} selectorString
     * @returns {boolean}
     */
    static _isValidCssSelector(selectorString) {
        if (typeof selectorString !== 'string' || selectorString.trim() === '') {
            return false;
        }
        try {
            document.createDocumentFragment().querySelector(selectorString);
            return true;
        } catch (e) {
            return false;
        }
    }

    /**
     * @param hash hash or css query selector
     */
	static scrollToLinkHash(hash) {
        if (!HashScrolling._isValidCssSelector(hash)) return;
        const targetElement = document.querySelector(hash);
        HashScrolling.scrollToLink(targetElement);
    }


    static scrollToLink(targetElement) {
		if (!targetElement) return;

        // if the element is in an accordion, open it first
        let accordionItem = targetElement.closest('.accordion__item:not(.accordion__item--is-active)');
        if(accordionItem) {
            accordionItem.querySelector('.accordion__item-title').click();
        }

        let top = HashScrolling._getScrollTop(targetElement);
		window.scrollTo({
			behavior: 'smooth',
			left: 0,
			top: top,
		});

		// TODO Find better solution
		// header height changes, when it becomes fixed, so we need to re-ajust a bit
		setTimeout(() => {
            let top = HashScrolling._getScrollTop(targetElement);
			window.scrollTo({
				behavior: 'smooth',
				left: 0,
				top: top,
			});
		}, 300)
	}

    static scrollToLinkHashIfIsAbove(hash) {
        if (!HashScrolling._isValidCssSelector(hash)) return;
        const targetElement = document.querySelector(hash);
        HashScrolling.scrollToLinkIfIsAbove(targetElement);
    }

    static scrollToLinkIfIsAbove(targetElement) {
        if (!targetElement) return;

        if(HashScrolling._getScrollTop(targetElement) > window.scrollY) {
            HashScrolling.scrollToLink(targetElement);
        }
    }
}
